import api from './api';
import type {
  TaskDefinition,
  TaskExecution,
  TaskListResponse,
  TaskExecutionListResponse,
  TaskInput,
  IterationConfig,
} from '../types';

export const taskApi = {
  // Task CRUD
  create: async (task: {
    name: string;
    description: string;
    inputs: TaskInput[];
    agentIds?: string[];
    iterationConfig?: Partial<IterationConfig>;
    projectId?: string;
  }) => {
    const { data } = await api.post<TaskDefinition>('/tasks', task);
    return data;
  },

  list: async (params?: { page?: number; pageSize?: number; isTemplate?: boolean; projectId?: string }) => {
    const { data } = await api.get<TaskListResponse>('/tasks', { params });
    return data;
  },

  get: async (id: string) => {
    const { data } = await api.get<TaskDefinition>(`/tasks/${id}`);
    return data;
  },

  update: async (id: string, updates: Partial<TaskDefinition>) => {
    const { data } = await api.put<TaskDefinition>(`/tasks/${id}`, updates);
    return data;
  },

  delete: async (id: string) => {
    await api.delete(`/tasks/${id}`);
  },

  // Execution
  execute: async (taskId: string) => {
    const { data } = await api.post<TaskExecution>(`/tasks/${taskId}/execute`);
    return data;
  },

  // Task Execution CRUD
  listExecutions: async (params?: {
    page?: number;
    pageSize?: number;
    taskId?: string;
    status?: string;
  }) => {
    const { data } = await api.get<TaskExecutionListResponse>('/task-executions', { params });
    return data;
  },

  getExecution: async (id: string) => {
    const { data } = await api.get<TaskExecution>(`/task-executions/${id}`);
    return data;
  },

  deleteExecution: async (id: string) => {
    await api.delete(`/task-executions/${id}`);
  },

  cancelExecution: async (id: string) => {
    const { data } = await api.post<TaskExecution>(`/task-executions/${id}/cancel`);
    return data;
  },

  pauseExecution: async (id: string) => {
    const { data } = await api.post<TaskExecution>(`/task-executions/${id}/pause`);
    return data;
  },

  resumeExecution: async (id: string, feedback?: string) => {
    const { data } = await api.post<TaskExecution>(`/task-executions/${id}/resume`, { feedback });
    return data;
  },

  sendFeedback: async (id: string, feedback: string) => {
    const { data } = await api.post<TaskExecution>(`/task-executions/${id}/feedback`, { feedback });
    return data;
  },
};
